import { Labeling } from "../../store/appVersion/labeling";
import LabelingInfo, { getLabelForIsForClinicalUse } from "./LabelingInfo";
import { MVisionInfo } from "../../store/appConfig/appDeploymentInfoTypes";

interface ModuleViewProps {
    productLabel: Labeling,
    mvisionInfo?: MVisionInfo;
}

const ModuleView = (props: ModuleViewProps) => {

    const { productLabel, mvisionInfo } = props;

    const getModuleInfoForClipboard = () => {

        const info = `
${productLabel.manufacturer} ${productLabel.manufacturerModelName}
Software Version: ${productLabel.systemVersion}
Clinical Use: ${getLabelForIsForClinicalUse(productLabel.isClinical)}
Instructions for Use: ${mvisionInfo?.ifuUrl || ''}
Email: ${mvisionInfo?.email || ''}
Website: ${mvisionInfo?.webAddress || ''}`.trim();

        return info;
    };

    return (
        <>
            <LabelingInfo
                softwareVersion={productLabel.systemVersion}
                clinicalUse={productLabel.isClinical}
                description={productLabel.description}
                mvisionInfo={mvisionInfo}
                udi={undefined}
                manufacturer={productLabel.manufacturer}
                showManufacturingInformation={false}
                showFooter={false}
                moduleName={productLabel.manufacturerModelName}
                className="module-info"
                getLabelInfoForClipboard={getModuleInfoForClipboard}
            />
        </>
    );
}

export default ModuleView;
